import { render, staticRenderFns } from "./OverviewCafe.vue?vue&type=template&id=25eb8211"
import script from "./OverviewCafe.vue?vue&type=script&lang=js"
export * from "./OverviewCafe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports